import { GetRequest, PostRequest } from "@/api/service"

const ControllerName = "AccountManagersBrokersSettings"

export const getAccountManagersBrokers = () =>
    GetRequest(`${ControllerName}/get-account-managers-brokers`)


export const assignBrokerToAccountManager = ({brokerId,accountManagerId})=>
    PostRequest(`${ControllerName}/assign-broker-to-account-manager`, {brokerId,accountManagerId})